<template>
  <div class="general-info">
    <div class="general-info__container">
      <div class="general-info__row">
        <div v-if="showDynamicMenu" class="floating-menu">
          <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
        </div>
        <div class="general-info__column">
          <div class="general-info__title">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Экскурсия по нашему центру</h1>
          </div>
          <div class="general-info__index-mg">
            <AppSwiperCenter :list_image="slides"/>
          </div>
        </div>

      </div>
      <div class="">
        <AppSwiperGalleryInside/>
      </div>
      <div class="">
        <AppSwiperGallery/>
      </div>
    </div>
  </div>

</template>
<script>
import AppSwiperGallery from '@/components/Gallery/SwiperGallery.vue'
import AppSwiperGalleryInside from '@/components/Gallery/SwiperGalleryInside.vue'
import AppSwiperCenter from '@/components/Gallery/SwiperCenter.vue'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppDocuments",
    components: {DynamicMenu, AppSwiperCenter, AppSwiperGalleryInside, AppSwiperGallery},
    metaInfo() {
      return {
        title: 'Галерея | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Галерея. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    data() {
      return {
        dynamicMenuItems: [],
        linksDepartment: 'about/gallery',
        slides: [
          { id: 1, image: require('../../assets/img/gallety-center-outside/1.jpg') },
          { id: 2, image: require('../../assets/img/gallety-center-outside/2.jpg') },
          { id: 3, image: require('../../assets/img/gallety-center-outside/3.jpg') },
          { id: 4, image: require('../../assets/img/gallety-center-outside/4.jpg') },
          { id: 5, image: require('../../assets/img/gallety-center-outside/5.jpg') },
          { id: 6, image: require('../../assets/img/gallety-center-outside/6.jpg') },
        ]
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/gallery');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    computed: {
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    mounted() {
      this.loadSiblingsForMenu();
    }
};
</script>
